module.exports = __webpack_public_path__ + "img/re_IMG_1223.2e27b4ad.jpeg";